(ns motorsaif.web.pages.business-sign-up
  (:require
   ["react" :as react]
   ["react-transition-group" :refer [CSSTransition SwitchTransition]]
   [clojure.string :as str]
   [goog.functions :refer [debounce]]
   [motorsaif.data-utils :as data-utils]
   [motorsaif.frontend-routes :as routes]
   [motorsaif.i18n :as i18n :refer [tr]]
   [motorsaif.validation :as validation]
   [motorsaif.web.components :as c]
   [motorsaif.web.components.step-form :as sf]
   [motorsaif.web.components.step-inputs :as si]
   [motorsaif.web.lib.form :as form]
   [motorsaif.web.storage :as storage]
   [motorsaif.web.svg :as svg]
   [re-frame.core :as rf]
   [reagent.core :as r]))

(defn review [{:keys [form]}]
  (let [trs (i18n/tr-scope [:business-signup :review])
        {:keys [*data]} form
        {:keys [business user]} @*data]
    [:div#review
     [:h1 (trs :review "Review")]
     (let [trs (i18n/tr-scope [:business-signup :review :user])
           {:user/keys [name email handle]} user]
       [:section.user
        [:h2 (trs :title "User Information")]
        [:div.grid.summary
         [:span.title (trs :email "Email")] [:span.val email]
         [:span.title (trs :handle "Handle")] [:span.val handle]]])

     (let [trs (i18n/tr-scope [:business-signup :review :business])
           {:business/keys [name email coords geo-location misc]} business
           {:keys [filters whatsapp]} misc]
       [:section.business
        [:h2 (trs :title "Business Information")]
        [:div.grid.summary
         [:span.title (trs :name "Name")] [:span.val name]
         [:span.title (trs :email "Email")] [:span.val email]
         [:span.title (trs :whatsapp "Whatsapp")] [:span.val whatsapp]
         [:span.title (trs :location "Location")] [:span.val geo-location]
         [:span.title (trs :map "Map")] [c/map-image coords]
         [:span.title (trs :services "Services")]
         [:div.feed-filters
          (into [:div.filter-list]
                (map-indexed #(c/service-filter
                               {:idx %1
                                :data %2}) filters))]]])]))

;; https://uxdesign.cc/user-onboarding-practices-that-you-cannot-miss-dff86a5c966a

(def ^:private new-account-steps
  {:start {:renderer si/biz-personal-account
           :validate [[:user :user/email]
                      [:user :user/handle]
                      [:user :user/handle-valid]
                      [:user :user/password]]
           :next :verify-code}
   :verify-code {:renderer si/verify-email-new-user
                 :validate [[:user :user/email-verified]]
                 :next :business}
   :business {:renderer si/business-information
              :validate [[:business :business/name]
                         [:business :business/email]]
              :next :services}
   :services {:renderer si/services
              :next :location
              :validate [[:business :business/misc :filters]]}
   :location {:renderer si/location
              :next :whatsapp
              :validate [[:business :business/coords]]}
   :whatsapp {:renderer si/whatsapp
              :next :review
              :validate [[:business :business/misc :whatsapp]
                         [:business :business/misc :whatsapp-verified]]}
   :review {:renderer review
            :finish true}})

(def ^:private existing-account-steps
  {:start {:renderer si/business-information
           :validate [[:business :business/name]
                      [:business :business/email]]
           :next :services}
   :photos {:renderer si/photos
            :next :services}
   :services {:renderer si/services
              :next :location
              :validate [[:business :business/misc :filters]]}
   :location {:renderer si/location
              :next :whatsapp
              :validate [[:business :business/coords]]}
   :whatsapp {:renderer si/whatsapp
              :next :review
              :validate [[:business :business/misc :whatsapp]
                         [:business :business/misc :whatsapp-verified]]}
   :review {:renderer review
            :finish true}})

(defn form []
  (let [form-key :ez-biz-signup
        init-data
        (or
         (storage/get form-key)
         {:business {:business/misc {:filters [{}]}}
          :user {}})

        current-user? @(rf/subscribe [:user])
        steps (if current-user?
                existing-account-steps
                new-account-steps)
        validation (if current-user?
                     validation/business-signup
                     validation/business+owner-signup)
        ;; init-data {}
        on-submit (fn [{:keys [all-data]}]
                    (let [all-data (data-utils/remove-empty-vals all-data)
                          req {:type :POST
                               :url "/api/businesses"
                               :params {:data all-data}
                               :id form-key
                               :handler
                               (fn [{:keys [success data ex-message] :as res}]
                                 ;; (:ex-message zher)
                                 ;; (:data zher)
                                 (cond
                                   ex-message
                                   (rf/dispatch [:toast {:type "error"
                                                         :message ex-message}])
                                   data
                                   (let [biz-id (:db/id data)]
                                     (storage/clear form-key)
                                     (rf/dispatch [:toast {:type "success"
                                                           :message "Business created! Reloading..."}])
                                     (rf/dispatch  [:common/navigate! :home])
                                     (js/setTimeout (fn []
                                                      (rf/dispatch [:swap-current-owner biz-id]))
                                                    1000)))
                                 ;; (def zher res)
                                 #_(let [biz-id (:db/id data)]
                                     (rf/dispatch [:swap-current-owner biz-id]))
                                 )
                               :error-handler (fn [_res]
                                                (rf/dispatch [:toast {:type "error"
                                                                      :message "Failed to create. Try again."}])
                                                (println "Error creating"))}]

                      (rf/dispatch [:do-ajax req])))

        form-args {:schema validation
                   :change-watch #(storage/write form-key %)
                   :on-submit
                   {:valid on-submit
                    :invalid (fn [error]
                               (let [error-titles ((:error-titles-fn error) :new-request)]
                                 (rf/dispatch [:toast {:type "error"
                                                       :timeout 5000
                                                       :title (tr :page.new-request.submit.invalid/title)
                                                       :message (str/join ", " error-titles)}])))}
                   :init-data init-data}
        {:keys [*data form-params] :as form} (form/make-form form-args)]
    (fn []
      [:div#business-step-form
       [:form.default
        form-params
        [sf/step-form {:steps steps
                       :form form
                       :title "Business Registration"
                       :init-path [:start]}]]])))

(defn feature-carousel [features]
  (let [ref (react/createRef)
        *img-idx (r/atom 0)

        *scroll-container (atom nil)

        *renderer-array (atom nil)
        gen-renderer-array (fn []
                             (reset! *renderer-array
                                     (mapv (fn [i]
                                             (* i (+ 10 ; margin-right from CSS
                                                     (.-clientWidth (.-current ref)))))
                                           (range (count features)))))

        ;; _ (def hae ref)
        on-scroll (debounce (fn [sl]
                              (let [item-array (or @*renderer-array (gen-renderer-array))]
                                (let [slack 30
                                      found-offset (first (filter #(<= (- sl slack) % (+ sl slack)) item-array))]
                                  (when found-offset
                                    (reset! *img-idx (.indexOf item-array found-offset))))))
                            15)]
    (r/create-class
      {:reagent-render
       (fn []
         [:div.features-carousel
          {:ref ref}
          [:div.wrapper
           (into [:div.features.hide-bar
                  {:ref (fn [c]
                          (when c
                            (reset! *scroll-container c)))
                   :on-scroll #(on-scroll (.-scrollLeft (.-target %)))}]
                 (map-indexed
                  (fn [idx renderer]
                    [(fn [renderer]
                       [:div.wrap
                        renderer
                        [:div
                         (-> {:on-load
                              (fn [_]
                                (when (= (count features)
                                         (count @*renderer-array))
                                  (set! (.-scrollLeft @*scroll-container) 0)))})]])
                     renderer])
                  features))]
          (when (> (count features) 1)
            [(fn []
               (into [:div.dots]
                     (map (fn [idx]
                            [:span.dot
                             {:class (when (= idx @*img-idx) "active")}])
                          (range (count features))))) @*renderer-array])])})))

(defn start []
  (let [trs (i18n/tr-scope [:page :business-signup])]
    [:div.start
     [:a.svg-logo
      {:href "/"}
      svg/logo]
     [:div.for-biz
      [:h1 (trs :title "Business Account")
       [:i.fa-duotone.fa-badge-check]]]

     ;; [c/lang-selector]
     ;; Here should be selling points.
     ;; Show quickly how it works by
     ;; 1) Showing customer requests
     ;; 2) Show they can send a message
     ;; 3) A user can chat with them directly
     ;; 4) User can see their profile and go to them directly

     (let [trs (i18n/tr-scope [:page :business-signup :feature-carousel])]
       [(fn []
          [feature-carousel
           [[:div.feature
             [:img {:src "/static/img/signup/bizcaro1.webp"}]
             [:p (trs :one "Increase sales by finding new customers")]]

            [:div.feature
             [:img {:src "/static/img/signup/bizcaro2.webp"}]
             [:p (trs :two "View customer requests that need your business")]]

            [:div.feature
             [:img {:src "/static/img/signup/bizcaro3.webp"}]
             [:p (trs :three "Communicate via instant messages")]]

            [:div.feature
             [:img {:src "/static/img/signup/bizcaro4.webp"}]
             [:p (trs :four "Customers can view your profile and go to you directly")]]]])])

     [:div.cta
      [:a.btn.secondary.full
       {:on-click #(storage/clear :ez-biz-signup)
        :href (routes/path-for :business-sign-up-step {:step :start})}
       (trs :get-started "Get Started")]]

     [:p.terms (trs [:terms :by] "By continuing you agree to the ")
      [:br]
      [:a
       {:href (routes/path-for :privacy)}
       (trs [:terms :privacy] "Privacy Policy")]
      " "
      (trs [:terms :and] "and")
      " "
      [:a
       {:href (routes/path-for :terms)}
       (trs [:terms :terms] "Terms")]]]))

;; @(rf/subscribe [:route/parameters])
;; (routes/path-for :business-sign-up)
;; (routes/path-for :business-sign-up-step {:step "df3"})
(defn root []
  (let [{:keys [name]} (:data @(rf/subscribe [:route/data]))]
    [:div.container-sm.card-elevated
     [:> SwitchTransition
      [:> CSSTransition
       {:timeout 100
        :key name
        :class-names "step-form"}
       (condp = name
         :business-sign-up-step
         [form]
         :business-sign-up
         [:div#business-sign-up
          [start]])]]]))

;; NOTE
;; TWO WAYS to register a user is awful.
;; This business form should NOT include the user stuff, rather
;; the user stuff should segue into the business thing when required.

(comment
  (rf/dispatch [:assoc-data :user {:db/id 17592186053644,
                                   :user/status :verified,
                                   :user/name "Tahir Ahmad",
                                   :user/handle "tahir-golden-garage",
                                   :user/password
                                   "bcrypt+sha512$ef95ef6a2a7780ddb6b31149c0c4c5d5$12$2302f58db1b7e2b56fe3d4f454572c6dd3cd0c9eda4fa896",
                                   :user/email "omar@naomarik.com"}]))
